import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useNotifications } from 'src/utils/hooks';

const DELETE_CONVERSATION_MUTATION = gql`
  mutation DeleteConversationWithRelatedData($params: DeleteConversationWithRelatedDataInput!) {
    deleteConversationWithRelatedData(params: $params) {
      conversationId
    }
  }
`;

export const useConversationDelete = () => {
  const { showSuccessAlert, showErrorAlert } = useNotifications();
  const [deleteConversationMutation] = useMutation(DELETE_CONVERSATION_MUTATION, {
    onCompleted: () => {
      showSuccessAlert('Conversation Deleted');
    },
    onError: (error) => {
      console.error(error);
      showErrorAlert('Something went wrong deleting conversation, please try again');
    },
  });

  const deleteConversation = useCallback(
    (conversationId: string, hardDelete = false) => {
      return deleteConversationMutation({
        variables: {
          params: {
            conversationId,
            softDelete: !hardDelete,
          },
        },
        optimisticResponse: {
          deleteConversationWithRelatedData: {
            conversationId,
          },
        },
        update(cache) {
          const id = cache.identify({
            __typename: 'Conversation',
            id: conversationId,
          });

          cache.evict({ id });
          cache.gc();
        },
      });
    },
    [deleteConversationMutation],
  );

  return { deleteConversation };
};
